import axios from "axios";
// import _ from "lodash";
import { config } from "constants/config";

export const settings = {
  baseURL: `${config.baseUrl}`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json;charset",
  },
};

const instance = axios.create(settings);

export default {
  get(url, request) {
    return instance
      .get(url, request)
      .then(response => Promise.resolve(response))
      .catch(error => {
        if (error.statusCode === 91) {
          return;
        }
        return Promise.reject(error.response.data, error.response.data);
      });
  },
  post(url, request) {
    return instance
      .post(url, request)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error.response.data, error.response));
  },
  put(url, request) {
    return instance
      .put(url, request)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error.response.data, error.response.data));
  },
  patch(url, request) {
    return instance
      .patch(url, request)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error.response.data, error.response.data));
  },
  delete(url, request) {
    return instance
      .delete(url, request)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error.response.data, error.response.data));
  },
};